/* NewEden2.0 — Product recommendations loader (Shopify Section Rendering API) */
(function () {
  if (window.NovaProductRecommendationsLoaded) return;
  window.NovaProductRecommendationsLoaded = true;

  var observer;

  function loadRecs(el) {
    if (el.getAttribute('data-recommendations-requested') === 'true') return;
    var url = el.getAttribute('data-url');
    if (!url) return;
    el.setAttribute('data-recommendations-requested', 'true');
    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (text) {
        var html = new DOMParser().parseFromString(text, 'text/html');
        var fresh = html.querySelector('[data-product-recommendations]');
        var hasProducts = fresh && fresh.querySelector('.product-card');
        if (hasProducts) {
          el.innerHTML = fresh.innerHTML;
          el.hidden = false;
          el.setAttribute('data-recommendations-state', 'ready');
          // Ensure injected reveal elements become visible (observer won't catch innerHTML swaps)
          el.querySelectorAll('[data-reveal], .reveal').forEach(function (r) { r.classList.add('is-revealed'); });
        } else {
          el.hidden = true;
          el.setAttribute('data-recommendations-state', 'empty');
        }
      })
      .catch(function () {
        el.hidden = true;
        el.setAttribute('data-recommendations-state', 'failed');
      });
  }

  function schedule(el) {
    if (el.getAttribute('data-recommendations-requested') === 'true') return;
    if ('IntersectionObserver' in window) {
      if (!observer) {
        observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            observer.unobserve(entry.target);
            loadRecs(entry.target);
          });
        }, { rootMargin: '500px 0px' });
      }
      observer.observe(el);
    } else {
      loadRecs(el);
    }
  }
  function init(scope) {
    (scope || document).querySelectorAll('[data-product-recommendations][data-url]').forEach(schedule);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
